exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dot{background:#fff;border-radius:50%;height:10px;width:10px;margin-left:2.5px;margin-right:2.5px;opacity:.6;transition:.3s}.active-dot{background:#fff!important;opacity:1;height:14px;width:14px}.carousel-dots{bottom:24px!important}", ""]);

// exports
